// Reviews word in site chrome (footer / mobile menu). Reviews V5 (Founder 30/09/26): ALWAYS "המלצות" — the ?reviews= preview
// switch is retired (lib/reviewsPreview.ts). Kept as a component so existing imports keep working.
import { REVIEWS_WORD } from '@/lib/reviewsPreview';

export default function ReviewsV2Word() {
  return <>{REVIEWS_WORD}</>;
}
